var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBabyBody(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 487,
    height: 355,
    viewBox: "0 0 487 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467 212.5C457.5 161.5 440.199 128.5 430.5 111C413.873 81 384 53.0187 356 47C328 40.9813 309 32.4643 302.5 25.5C296 18.5357 289.5 10.5 287.194 1.5H198.18C195.5 10.5 184.821 21.6832 180 25.5C171 32.625 156.5 44 130.5 47C104.5 50 61 78.5 48 111C34.9999 143.5 26.4885 160.5 18.9998 212.5C11.5111 264.5 -3.49943 303.5 3.99982 352.526H87.9998C109.15 305 100.5 270 113.74 168.5C104 215.5 102.702 291 117 352.526H378.24C396.5 291 390.23 219.5 378.24 168.5C396.5 254.5 383 293 400 352.526H484C488.5 301.5 476.5 263.5 467 212.5Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyBody);
export default __webpack_public_path__ + "static/media/baby-body.1c926899.svg";
export { ForwardRef as ReactComponent };